import axios from 'axios'

const state = {
  isFetching: false,
  isMore: false,
  userPoints: []
}

const actions = {
  fetchUserPoints: async ({commit}, params) => {
    if (params.page === 0) {
      commit('SET_USER_POINTS', [])
      commit('SET_IS_MORE', true)
    }
    const url = 'user-points'
    let {data} = await axios.get(url, { params })
    if (!data.error) {
      if (params.page > 0) {
        commit('ADD_USER_POINTS', data.user_points)
      } else {
        commit('SET_USER_POINTS', data.user_points)
      }
    } else {
      commit('SET_IS_REQUEST', false)
      commit('SET_IS_MORE', false)
    }
  }
}

const mutations = {
  SET_IS_REQUEST: (state, data) => {
    state.isFetching = data
  },
  SET_IS_MORE: (state, data) => {
    state.isMore = data
  },
  SET_USER_POINTS: (state, userPoints) => {
    state.userPoints = userPoints
    state.isFetching = false
    state.isMore = true
  },
  ADD_USER_POINTS: (state, userPoints) => {
    state.isFetching = false
    state.isMore = true
    for (let key in userPoints) {
      state.userPoints.push(userPoints[key])
    }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.point.js